// // PaymentTerms.jsx

import React from "react";
import "./PaymentTerms.css";

const PaymentTerms = () => {

  const paymentTerms = [
    "100% TT",
    "100% Advance Payment",
    "100% Irrevocable Confirmed LC",
    "Onsite LC",
    "50% Advance + 50% Irrevocable Confirmed LC",
  ];

  const incoTerms = [
    "Contract Period : 3 Months, 6 Months, 1 Year, 3 Years Available",
    "No Price Fixation",
    "MOQ - Minimum Order Quantity Available",
    "Standard Packing : 5 KG, 10 KG Available & Importers Discretion",
    "Stand by Brand Available",
    "Third Party Inspection Available",
    "QC - Quality Control Available",
  ];

  return (
    <div className="payment-page">

      {/* HERO SECTION */}
      <section className="payment-hero">

        <div className="payment-overlay"></div>

        <div className="payment-hero-content">

          <h1>Payment & INCO Terms</h1>

          <p>
            Transparent trade practices, secure payment structures,
            and globally trusted export operations.
          </p>

        </div>

      </section>

      {/* PAYMENT TERMS */}
      <section className="terms-section">

        <div className="terms-image">

          <img
            src="https://ik.imagekit.io/bapyu1ycr/common%20assets/ship3.jpg"
            alt="Payment Terms"
          />

        </div>

        <div className="terms-content">

          <span className="section-tag">
            Secure Transactions
          </span>

          <h2>Payment Terms</h2>

          <p className="terms-intro">
            Trust and transparency form the foundation of our export
            operations. We offer flexible and internationally accepted
            payment methods tailored to different product categories
            and business requirements.
          </p>

          <div className="terms-list">

            {paymentTerms.map((item, index) => (
              <div className="term-item" key={index}>

                <span>✔</span>

                <p>{item}</p>

              </div>
            ))}

          </div>

          <div className="terms-highlight">

            <h3>Why Clients Trust Us</h3>

            <p>
              Our credibility can be verified across India through
              certifications, quality assurance practices, and transparent
              export procedures.
            </p>

            <p>
              We also provide product visuals, inspection support,
              and product videos based on client requirements.
            </p>

          </div>

        </div>

      </section><hr/>

      {/* INCO TERMS */}
      <section className="terms-section reverse-section">

        <div className="terms-content">

          <span className="section-tag">
            Global Shipping Standards
          </span>

          <h2>INCO Terms</h2>

          <p className="terms-intro">
            Our export procedures follow internationally recognized
            INCO trade standards ensuring smooth logistics,
            shipment clarity, and operational efficiency.
          </p>

          <div className="terms-list">

            {incoTerms.map((item, index) => (
              <div className="term-item" key={index}>

                <span>✔</span>

                <p>{item}</p>

              </div>
            ))}

          </div>

          <div className="terms-highlight">

            <h3>Export Assurance</h3>

            <p>
              We maintain strict quality control systems,
              standardized packaging solutions, and reliable
              inspection procedures to ensure every shipment
              meets international expectations.
            </p>

          </div>

        </div>

        <div className="terms-image">

          <img
            src="https://ik.imagekit.io/bapyu1ycr/common%20assets/IncoTerm.jpg"
            alt="INCO Terms"
          />

        </div>

      </section>

    </div>
  );
};

export default PaymentTerms;